import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Laura', 'Ana', 'José', 'Sofía', 'Diego', 'Valentina', 'Juan', 'Camila', 'Roberto', 'Patricia', 'Fernando', 'Isabel', 'Miguel', 'Carmen', 'Lucía', 'Martín', 'Gabriela', 'Santiago'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Salvador de Jujuy', 'Corrientes', 'Santiago del Estero', 'San Fernando del Valle de Catamarca', 'Formosa', 'San Luis', 'La Rioja', 'Río Cuarto', 'Comodoro Rivadavia', 'San Nicolás', 'Quilmes', 'Lanús', 'Banfield', 'Lomas de Zamora', 'Avellaneda'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
        const nextDelay = Math.random() * (15000 - 8000) + 8000;
        setTimeout(showNotification, nextDelay);
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-191">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 z-50 bg-white rounded-lg shadow-2xl p-4 flex items-center gap-4 max-w-xs border-l-4 border-[#FF6B35]" data-id="element-192">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-193">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-194" />
          </div>
          <div data-id="element-195">
            <p className="font-bold text-gray-900 text-sm" data-id="element-196">
              {currentData.name} de {currentData.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-197">
              acaba de comprar el Megapack
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-198">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}